import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '../../../../../shared/translate/translate.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatExpansionModule } from '@angular/material';
import { AlertCommentAddComponent } from './alert-comment-add.component';

@NgModule({
  declarations: [AlertCommentAddComponent],
  imports: [
    CommonModule,
    IonicModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    MatExpansionModule
  ],
  exports: [AlertCommentAddComponent]
})
export class AlertCommentAddModule { }
